import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import clickShowTag from '@/components/clickShowTag.vue';
import tagModel from '@/components/tagModel.vue';
import tagList from '@/components/tagList.vue';
import { unitResource } from './../../insurance/underwritingManage/request';
import { agencyResource } from './../../insurance/organizationalManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { customerResource } from './../../system/customerManage/request';
import { downloadFileFun, LANGUAGE_RESOURCE } from '@/utils/public';
import { downloadPolicy, policyList, policyZip, getTags, policyNoEdit } from './request';
import { mapState } from 'vuex';
import { insuranceResource, getArea } from './../../insurance/insuranceManage/request';
import { PAYSTATUS } from '@/views/order/homeManage/request';
import selectShowColumn from './selectShowColumn.vue';
import moment from 'moment';
import datePicker from '@/components/datePicker.vue';
export default {
  components: {
    clickShowTag,
    tagModel,
    tagList,
    selectShowColumn,
    datePicker
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      PAYSTATUS,
      showItem: false,
      tagShow: false,
      showVisible: false,
      form: {
        createAt: '',
        agencyId: undefined,
        tags: '',
        content: '',
        insuranceId: undefined,
        applicationId: undefined,
        customerId: undefined
      },
      unitList: [],
      intermediaryList: [],
      applicationList: [],
      customerList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [],
      rearOptions: [],
      tagData: [],
      tagList: [],
      productList: [],
      applicationTime: [],
      areaValue: [],
      form1: {
        dataId: ''
      },
      rules: {
        dataId: [{
          required: true,
          message: '请输入保单号',
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 5,
          max: 200,
          trigger: 'blur',
          message: '最少输入5字符，最多输入200字符',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }]
      },
      editRecordIndex: ''
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    this.getAreaOptions();
    if (this.accountInfo.tag == 0) {
      this.form.customerId = this.accountInfo.customerId;
      this.agencyFun();
      this.getTagsFun();
      this.getDataFun();
      this.applicationFun();
    } else {
      customerResource({
        customerId: this.accountInfo.customerId,
        position: 'policy'
      }).then(res => {
        this.customerList = res;
        if (res.length == 0) {
          return false;
        }
        let arr = res.filter(item => item.id == Number(sessionStorage.getItem('policyCustomerId')));
        this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('policyCustomerId')) : res[0].id;
        sessionStorage.setItem('policyCustomerId', this.form.customerId);
        this.agencyFun();
        this.getTagsFun();
        this.getDataFun();
        this.applicationFun();
      });
    }
  },
  methods: {
    close() {
      this.showVisible = false;
    },
    okSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let editRecord = this.data[this.editRecordIndex];
          let params = {
            policyId: editRecord === null || editRecord === void 0 ? void 0 : editRecord.policyId,
            insuranceId: editRecord === null || editRecord === void 0 ? void 0 : editRecord.insuranceId,
            policyNo: this.form1.dataId
          };
          policyNoEdit(params).then(res => {
            this.$message.success(this.$t('编辑成功'));
            this.data[this.editRecordIndex].policyNo = res.policyNo;
            this.showVisible = false;
            this.editRecordIndex = '';
          });
        }
      });
    },
    editPolicy(index) {
      this.editRecordIndex = index;
      this.showVisible = true;
      this.$nextTick(() => {
        this.$refs.dataFrom.resetFields();
      });
    },
    isShowMore(record) {
      let isShowMore = false;
      if (this.isAuth('customer.policyZip')) {
        // 下载保单按钮
        isShowMore = true;
      }
      if (this.isAuth('customer.personnelDetailsList')) {
        //人员明细按钮
        isShowMore = true;
      }
      if (this.isAuth('customer.correctRecordList')) {
        //批改记录按钮
        isShowMore = true;
      }
      return isShowMore;
    },
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      insuranceResource({
        applicationId: this.form.applicationId,
        position: 'policy',
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
    },
    getTagsFun() {
      this.tagData = [];
      this.tagList = [];
      let parameter = {};
      if (this.accountInfo.tag != 0) {
        parameter = {
          customerId: this.form.customerId
        };
      }
      getTags(parameter).then(res => {
        this.tagData = res;
      });
    },
    async getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.applicationTime[0] ? moment(this.applicationTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      obj.endAt = this.applicationTime[1] ? moment(this.applicationTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      const res = await policyList(obj);
      if (res.fieldConfig) {
        this.columns = res.fieldConfig.map(item => {
          let obj = item;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          if (item.dataIndex === 'payStatusName' || item.dataIndex === 'isTimely' || item.dataIndex === 'status') {
            item.customRender = (text, record) => {
              return h("span", [this.$t(text)]);
            };
          }
          if (item.dataIndex === 'tag') {
            obj.scopedSlots = {
              customRender: 'tag'
            };
          }
          return obj;
        });
        this.columns = this.columns.filter(item => item.dataIndex !== 'operate');
        this.columns.push({
          // title: '操作',
          scopedSlots: {
            customRender: 'action',
            title: 'customTitle'
          },
          align: 'center',
          class: 'column-action',
          width: 250,
          key: '9'
        });
      }
      this.data = res.items;
      this.pagination.total = res.totalNum;
    },
    onChange(date, dateString) {
      this.form.createAt = dateString || '';
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    agencyFun() {
      this.form.agencyId = undefined;
      let customerId = this.accountInfo.tag === 0 ? this.accountInfo.customerId : this.form.customerId; //客户传自己的customerId 中介传选择的表单归属的id
      agencyResource({
        unitId: this.form.unitId,
        customerId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
      if (!this.form.unitId) {
        this.agencyFun();
      }
    },
    applicationFun() {
      applicationResource({
        customerId: this.form.customerId,
        position: 'policy'
      }).then(res => {
        this.applicationList = res;
      });
      this.getInsuranceFun();
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    downloadFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const language = sessionStorage.getItem('locale') || 'zh_CN';
      obj.language = LANGUAGE_RESOURCE[language];
      downloadPolicy(obj).then(res => {
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/vnd.ms-excel', this.$t('保单列表') + time + '.xlsx');
      });
    },
    async handleDownload(val) {
      const res = await policyZip({
        policyId: val.policyId
      });
      downloadFileFun(res, 'application/zip', val.policyNo + this.$t('电子保单') + '.zip');
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    },
    filterOption2(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    customerChange() {
      sessionStorage.setItem('policyCustomerId', this.form.customerId);
      this.form.applicationId = undefined;
      this.agencyFun();
      this.tagList = [];
      this.getTagsFun();
      this.searchFun();
      this.applicationFun();
    },
    resetFun() {
      this.tagList = [];
      this.tagShow = false;
      this.tagData = this.tagData.map(item => {
        if (item.children && item.children.length) {
          item.children = item.children.map(child => {
            delete child.choice;
            return child;
          });
          return item;
        }
      });
      this.applicationTime = [];
      this.$refs.applicationTime && this.$refs.applicationTime.resetData();
      this.areaValue = [];
      this.form = {
        createAt: '',
        agencyId: undefined,
        structureId: undefined,
        applicationId: undefined,
        customerId: this.form.customerId,
        tags: '',
        insuranceId: undefined,
        content: ''
      };
    },
    onChangeTime(date) {
      this.applicationTime = date;
    },
    settingColumn() {
      this.$refs.selectShowColumn.openModal();
    },
    getAreaOptions() {
      getArea({}).then(res => {
        let loop = data => {
          if (!Array.isArray(data)) return [];
          return data.map(item => {
            if (item.child) {
              item.children = loop(item.child);
            }
            item.label = item.name;
            item.value = item.code;
            return item;
          });
        };
        this.rearOptions = loop(res);
      });
    },
    areaChange(value) {
      if (value && value.length) {
        let areaCode = value[value.length - 1];
        this.$set(this.form, 'areaCode', areaCode);
      } else {
        this.$set(this.form, 'areaCode', undefined);
      }
    },
    toPersonnelDetail(record) {
      this.$router.push({
        name: 'customerPersonnelDetail',
        params: {
          id: record.policyId,
          policyType: record.policyPurpose || 'other'
        }
      });
    },
    toCorrectionRecord(record) {
      if (!record.customerInsuranceDeclarationMethod) {
        this.$message.error(this.$t('请联系管理员配置申报方式'));
        return;
      }
      this.$router.push({
        name: 'customerCorrectionRecord',
        params: {
          id: record.policyId
        }
      });
    }
  }
};